export default __webpack_public_path__ + "static/media/SAS0160.34I-34912_-19766_0.fede61e6.jpg";